export const normalizeCachedQueryId = (
  cachedQueryId: string | null | undefined
): string | undefined => {
  const normalized = cachedQueryId?.trim();
  return normalized ? normalized : undefined;
};
